import { render } from "./Linkedin.vue?vue&type=template&id=38c162b2&scoped=true"
import script from "./Linkedin.vue?vue&type=script&lang=js"
export * from "./Linkedin.vue?vue&type=script&lang=js"

import "./Linkedin.vue?vue&type=style&index=0&id=38c162b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c162b2"]])

export default __exports__